import { Suspense } from "react";
import { Loader } from "../shared/index";

const QueryLoadingBoundary = ({ children }) => {
  return (
    <Suspense
      fallback={
        <div
          style={{
            display: "grid",
            placeItems: "center", 
            minHeight: "100vh",
          }}
        >
          <Loader title="VITAURA app loading....." />
        </div>
      }
    >
      {children}
    </Suspense>
  );
};

export default QueryLoadingBoundary;
